module.exports = __webpack_public_path__ + "static/media/Support.7429269e.svg";